export default __webpack_public_path__ + "static/media/select_estimate_type.248efd28.svg";